export default __webpack_public_path__ + "static/media/carteira-trabalho.04eb5ecd.jpg";